
import React, { useEffect, useState } from "react";
import { FaDownload, FaStar } from "react-icons/fa";
import { store } from "../../App";
import KpiService from "../../Services/KpiService";
import ShowAlert from "../alert";



const userid = localStorage.getItem("username");
const deptid = localStorage.getItem("deptid");
const roleid = localStorage.getItem("role");
let districtid = localStorage.getItem("districtid");

export default function FeedbackBookViewer({ onClose, showRating = false }) {

    const [data, setData] = useState(null);
    const [downloadItem, setDownloadItem] = useState(null);
    const [rating, setRating] = useState("");
    const [comment, setComment] = useState("");

    useEffect(() => {
        const open = (e) => {
            setData(e.detail.documentData);
            setDownloadItem(e.detail.downloadItem);
            setRating(0);
            setComment("");
        };

        const closeViewer = () => {
            setData(null);
            setDownloadItem(null);
            onClose?.();
        };

        window.addEventListener("feedback-book-open", open);
        window.addEventListener("feedback-book-close", closeViewer);

        return () => {
            window.removeEventListener("feedback-book-open", open);
            window.removeEventListener("feedback-book-close", closeViewer);
        };
    }, [onClose]);

    if (!data) return null;

    const isEvaluated = data?.is_eval_required === true;

    const savedRating = String(data?.eval_grade ?? "").trim();
    const isRatingSubmitted = ["Excellent", "Good", "Average", "Poor"].includes(savedRating);

    const {
        fname,
        designation,
        batchYear,
        currentServiceStatus,
        trainingInstitute,
        currentPosting,
        nameOfTopic,
        subTopicNames,
        topic1Feedback,
        pgapsAndChallenges,
        potentialSol,
        bestPractices,
        otherSuggestions,
        suggestedActionMatrix,
        topicValue,
        eval_remarks,
    } = data;

    const cleanText = (value) => {
        const div = document.createElement("div");
        div.innerHTML = value ?? "";
        return (div.textContent || "").replace(/\u00a0/g, " ").trim();
    };

    const hasData = (value) => cleanText(value) !== "";
    const isTopic1 = topic1Feedback?.length > 0;
    const isProbationer =
        ["probationer", "1"].includes(String(currentServiceStatus).toLowerCase());

    const matrixFields = [
        "issue", "proposed_action", "lead_agency",
        "supporting_agencies", "expected_outcome_timeline",
    ];

    const hasMatrix = suggestedActionMatrix?.some((row) =>
        matrixFields.some((key) => hasData(row[key]))
    );

    const RichContent = ({ value }) =>
        hasData(value) ? (
            <div className="feedback-rich-content" dangerouslySetInnerHTML={{ __html: value }} />
        ) : (
            <p className="feedback-empty">Not provided</p>
        );

    const Question = ({ title, value }) => (
        <section className="feedback-question">
            <h6>{title}</h6>
            <RichContent value={value} />
        </section>
    );

    const OfficerDetails = ({ label, value }) => (
        <li><b>{label}</b>{value || "—"}</li>
    );

    const close = () => {
        setData(null);
        setDownloadItem(null);
        setRating("");
        setComment("");
        onClose?.();
    };

    const handleSubmitRating = () => {
        if (!rating || !data?.ratingCfmsId || !data?.ratingTopicId) return;
        const params = { userId: userid, cfmsId: String(data.ratingCfmsId), nameOfTopic: String(data.ratingTopicId), evalGrade: rating, evalRemarks: comment.trim(), };
        store.dispatch({ type: "SHOW_SPINNER" });

        KpiService.snccsFeedbackFormEvalutionRequest(params)
            .then((res) => {

                if (String(res?.data?.SCODE) === "01") {
                    setData((prev) => ({
                        ...prev,
                        eval_grade: rating,
                        eval_remarks: comment.trim(),
                    }));

                    setRating("");
                    setComment("");


                } else {
                    console.log("error", res?.data?.SDESC || "Unable to submit the rating. Please try again.");
                }
            })
            .catch((error) => {
                console.error("Error submitting feedback rating:", error);

            })
            .finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
            });
    };

    return (
        <div className="feedback-book-overlay" role="dialog" aria-modal="true" aria-label="Feedback document viewer" tabIndex={-1} onClick={(e) => { if (e.target === e.currentTarget) close(); }} onKeyDown={(e) => { if (e.key === "Escape") close(); }} >
            <div className="feedback-book">
                <button className="feedback-book-close" onClick={close}
                    type="button" aria-label="Close feedback book" title="Close book">
                    ×
                </button>

                <div className="feedback-book-tabs">
                    <button type="button" className="btn btn-sm" style={{ padding: "2px", color: "#fff" }} onClick={() => { if (downloadItem) { window.dispatchEvent(new CustomEvent("feedback-book-download", { detail: downloadItem, })); } }} disabled={!downloadItem} >
                        <FaDownload />
                    </button>
                </div>

                <article className="feedback-book-page">
                    <header className="feedback-book-header">
                        <img src="/images/nitiaayog.png" alt="NITI Aayog" />
                        <h2>Sixth National Conference of Chief Secretaries</h2>
                        <h3>Feedback Note</h3>
                    </header>

                    <h3 className="feedback-section-title">
                        Section 1: Officer Name and Details
                    </h3>

                    <ul className="feedback-officer-details">
                        <OfficerDetails label="Name:" value={fname} />
                        <OfficerDetails label="Designation:" value={designation} />
                        <OfficerDetails label="Batch:" value={batchYear} />
                        <OfficerDetails label="Current Service Status:" value={currentServiceStatus} />
                        <OfficerDetails
                            label={isProbationer ? "Training Institute / Academy:" : "Current Posting:"}
                            value={isProbationer ? trainingInstitute : currentPosting}
                        />
                    </ul>

                    <h3 className="feedback-section-title">
                        Section 2: Feedback for Sixth National Conference of Chief Secretaries
                    </h3>

                    <Question title="1. Name of the Topic" value={nameOfTopic} />

                    {isTopic1 ? (
                        <div className="feedback-topic1">
                            {topic1Feedback.map((sub, i) => (
                                <section className="feedback-subtopic"
                                    key={sub.subTopicId ?? `${sub.name}-${i}`}>
                                    <h6>Specific Priority Area {i + 1}:</h6>
                                    <p>{sub.name || `Sub Topic ${i + 1}`}</p>
                                    <Question title={`${i + 1}.2 Policy Gaps and Challenges`}
                                        value={sub.pgapsAndChallenges} />
                                    <Question title={`${i + 1}.3 Potential Solutions`}
                                        value={sub.potentialSol} />
                                    <Question title={`${i + 1}.4 Best Practices`}
                                        value={sub.bestPractices} />
                                    {hasData(sub.otherSuggestions) && (
                                        <Question title={`${i + 1}.5 Other Suggestions`}
                                            value={sub.otherSuggestions} />
                                    )}
                                </section>
                            ))}
                        </div>
                    ) : (
                        <>
                            {!!subTopicNames?.length && (
                                <section className="feedback-question">
                                    <h4>Specific Priority Area(s)</h4>
                                    <ol>{subTopicNames.map((name, i) => <li key={`${name}-${i}`}>{name}</li>)}</ol>
                                </section>
                            )}

                            <Question title="2. Policy Gaps and Challenges" value={pgapsAndChallenges} />
                            <Question title="3. Potential Solutions" value={potentialSol} />
                            <Question title="4. Best Practices" value={bestPractices} />

                            {Number(topicValue) === 2 && hasMatrix && (
                                <section className="feedback-question">
                                    <h4>5. Suggested Action Matrix</h4>
                                    <div className="feedback-table-wrap">
                                        <table className="feedback-matrix">
                                            <thead>
                                                <tr>{["Issue", "Proposed Action", "Lead Agency",
                                                    "Supporting Agencies", "Expected Outcome / Timeline"]
                                                    .map((heading) => <th key={heading}>{heading}</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {suggestedActionMatrix.filter((row) =>
                                                    matrixFields.some((key) => hasData(row[key]))
                                                ).map((row, i) => (
                                                    <tr key={i}>
                                                        {matrixFields.map((key) => (
                                                            <td key={key}><RichContent value={row[key]} /></td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            )}

                            {Number(topicValue) !== 2 && hasData(otherSuggestions) && (
                                <Question title="5. Other Suggestions" value={otherSuggestions} />
                            )}
                        </>
                    )}

                    {(isEvaluated && showRating) && (
                        <section
                            style={{
                                marginTop: "24px",
                                padding: "16px",
                                border: "1px solid #d8e2ee",
                                borderRadius: "12px",
                                background: "#f8fafc",
                                width: "100%",
                                boxSizing: "border-box",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    marginBottom: "14px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "36px",
                                        height: "36px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "9px",
                                        background: "#fff0cc",
                                        color: "#b7791f",
                                        flexShrink: 0,
                                    }}
                                >
                                    <FaStar />
                                </div>

                                <div>
                                    <h4
                                        style={{
                                            margin: 0,
                                            fontSize: "15px",
                                            fontWeight: 700,
                                            color: "#183153",
                                        }}
                                    >
                                        Rating
                                    </h4>
                                    <p
                                        style={{
                                            margin: "4px 0 0",
                                            fontSize: "12px",
                                            color: "#64748b",
                                        }}
                                    >
                                        Select one grade for the submitted feedback.
                                    </p>
                                </div>
                            </div>

                            {isRatingSubmitted ? (
                                <>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            gap: "10px",
                                            padding: "12px",
                                            background: "#fff",
                                            border: "1px solid #dce5ee",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        <span style={{ fontSize: "12px", color: "#64748b" }}>
                                            Submitted Grade
                                        </span>

                                        <strong
                                            style={{
                                                padding: "5px 12px",
                                                borderRadius: "6px",
                                                background:
                                                    savedRating === "Excellent" ? "#e1f5e9" :
                                                        savedRating === "Good" ? "#e5efff" :
                                                            savedRating === "Average" ? "#fff2d6" :
                                                                "#ffe8e8",
                                                color:
                                                    savedRating === "Excellent" ? "#16804a" :
                                                        savedRating === "Good" ? "#245db0" :
                                                            savedRating === "Average" ? "#9a6700" :
                                                                "#c03939",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {savedRating}
                                        </strong>

                                        <span
                                            style={{
                                                marginLeft: "auto",
                                                color: "#16804a",
                                                fontSize: "11px",
                                                fontWeight: 600,
                                            }}
                                        >
                                            ✓ Rating Submitted
                                        </span>
                                    </div>

                                    {hasData(eval_remarks) && (
                                        <div style={{ marginTop: "12px" }}>
                                            <label
                                                style={{
                                                    display: "block",
                                                    marginBottom: "6px",
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                    color: "#334155",
                                                }}
                                            >
                                                Submitted Remarks
                                            </label>

                                            <div
                                                style={{
                                                    padding: "12px",
                                                    background: "#f8fafc",
                                                    border: "1px solid #dce5ee",
                                                    borderRadius: "8px",
                                                    color: "#334155",
                                                    fontSize: "12px",
                                                    lineHeight: 1.6,
                                                    whiteSpace: "pre-wrap",
                                                    overflowWrap: "anywhere",
                                                }}
                                            >
                                                {eval_remarks}
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                                            gap: "8px",
                                            marginBottom: "14px",
                                        }}
                                    >
                                        {["Excellent", "Good", "Average", "Poor"].map((grade) => {
                                            const colors = {
                                                Excellent: { text: "#16804a", bg: "#e1f5e9" },
                                                Good: { text: "#245db0", bg: "#e5efff" },
                                                Average: { text: "#9a6700", bg: "#fff2d6" },
                                                Poor: { text: "#c03939", bg: "#ffe8e8" },
                                            };

                                            const selected = rating === grade;

                                            return (
                                                <button
                                                    key={grade}
                                                    type="button"
                                                    onClick={() => setRating(grade)}
                                                    aria-pressed={selected}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "6px",
                                                        minWidth: 0,
                                                        padding: "10px 4px",
                                                        borderRadius: "8px",
                                                        border: `1px solid ${selected ? colors[grade].text : "#d7e0eb"
                                                            }`,
                                                        background: selected
                                                            ? colors[grade].bg
                                                            : "#fff",
                                                        color: colors[grade].text,
                                                        fontSize: "12px",
                                                        fontWeight: selected ? 700 : 500,
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <FaStar />
                                                    <span>{grade}</span>
                                                </button>
                                            );
                                        })}
                                    </div>

                                    <label
                                        htmlFor="feedback-remarks"
                                        style={{
                                            display: "block",
                                            marginBottom: "6px",
                                            fontSize: "12px",
                                            fontWeight: 600,
                                            color: "#334155",
                                        }}
                                    >
                                        Remarks <span style={{ fontWeight: 400 }}>(Optional)</span>
                                    </label>

                                    <textarea
                                        id="feedback-remarks"
                                        rows={3}
                                        maxLength={500}
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        placeholder="Enter your comments here..."
                                        style={{
                                            display: "block",
                                            width: "100%",
                                            boxSizing: "border-box",
                                            padding: "10px",
                                            border: "1px solid #d5deea",
                                            borderRadius: "8px",
                                            resize: "vertical",
                                            fontSize: "12px",
                                            outline: "none",
                                            background: "#fff",
                                        }}
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            gap: "10px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        <span style={{ fontSize: "11px", color: "#64748b" }}>
                                            {comment.length}/500 characters
                                        </span>

                                        <button
                                            type="button"
                                            disabled={!rating}
                                            onClick={handleSubmitRating}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "7px",
                                                padding: "9px 16px",
                                                border: "none",
                                                borderRadius: "7px",
                                                background: rating ? "#176b5b" : "#94a3b8",
                                                color: "#fff",
                                                fontSize: "12px",
                                                fontWeight: 600,
                                                cursor: rating ? "pointer" : "not-allowed",
                                            }}
                                        >
                                            Submit Rating
                                        </button>
                                    </div>
                                </>
                            )}
                        </section>
                    )}
                </article>

            </div>

            <style>{`
.feedback-book-overlay { position:fixed; inset:0; z-index:100000; display:flex; align-items:center; justify-content:center; padding:10px; background:#17202fd9; backdrop-filter:blur(5px); }

.feedback-book { position:relative; width:min(1180px,97vw); max-height:94vh; display:flex; flex-direction:column; overflow:hidden; border:1px solid #fff; border-radius:0px; background:#fffdf8; box-shadow:0 25px 70px #101c2c45; }

.feedback-book-tabs { color:#fff;display:flex; flex-wrap:wrap; align-items:center; gap:8px 20px; padding:12px 52px 12px 16px; background:linear-gradient(115deg,#172d49,#294867); border-bottom:3px solid #c6a567; }

.feedback-book-close { position:absolute; top:7px; right:8px; z-index:2; display:grid; place-items:center; width:32px; height:32px; padding:0; border:1px solid #d8c49b; border-radius:50%; background:#fffdf8; color:#243c57; font:24px Arial,sans-serif; cursor:pointer; box-shadow:0 2px 8px #0002; transition:.2s; }

.feedback-book-close:hover { background:#f4e8cf; color:#8c682e; transform:rotate(90deg); }

.feedback-book-page { min-height:0; overflow-y:auto; overscroll-behavior:contain; padding:20px clamp(14px,3vw,30px); background:linear-gradient(90deg,#eee8dc,#fffdf8 3%,#fffdf8 97%,#eee8dc); color:#394351; font:12px/1.55 Georgia,"Times New Roman",serif; scrollbar-width:thin; scrollbar-color:#b6a078 #f2ede3; }

.feedback-book-header { margin:0 auto 14px; padding:9px 12px; border:1px solid #e3d7bf; border-radius:6px; background:linear-gradient(135deg,#faf6ed,#f0e6d2); text-align:center; box-shadow:0 3px 10px #183b6010; }

.feedback-book-header img { width:36px; height:34px; object-fit:contain; margin-bottom:3px; }

.feedback-book-header h2 { margin:2px auto 4px; color:#243c57; font-size:16px; line-height:1.3; }

.feedback-book-header h3 { margin:0; color:#9c793e; font-size:10px; letter-spacing:1.5px; text-transform:uppercase; }

.feedback-book-header:after { content:""; display:block; width:42px; height:2px; margin:7px auto 0; background:#b99a60; }

.feedback-section-title { margin:20px 0 12px; padding:9px 12px; border-left:4px solid #c6a567; border-radius:3px 6px 6px 3px; background:linear-gradient(100deg,#243c57,#405975); color:#fffaf0; font-size:13px; line-height:1.45; }

.feedback-officer-details { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); column-gap:30px; margin:0; padding:4px 2px; list-style:none; }

.feedback-officer-details li { display:flex; align-items:baseline; gap:8px; min-width:0; padding:9px 2px; border-bottom:1px solid #e8dfd0; background:transparent; color:#394351; overflow-wrap:anywhere; font-size:11px; }

.feedback-officer-details li b { flex:0 0 42%; margin:0; color:#8c7043; font-size:10px; font-weight:700; text-transform:uppercase; }

.feedback-question { margin:11px 0; padding:12px 14px; border:1px solid #e6ddce; border-left:3px solid #b99a60; border-radius:6px; background:#fffefa; }

.feedback-question h6,.feedback-subtopic h6 { margin:0 0 7px; color:#344e6b; font-size:12px; line-height:1.5; }

.feedback-question h4 { margin:0 0 10px; color:#344e6b; font-size:13px; }

.feedback-rich-content { color:#45505e; overflow-wrap:anywhere; }

.feedback-rich-content p { margin:0 0 7px; }

.feedback-rich-content p:last-child { margin-bottom:0; }

.feedback-rich-content ul,.feedback-rich-content ol,.feedback-question ol { padding-left:20px; }

.feedback-rich-content img { max-width:100%; height:auto; }

.feedback-rich-content table { width:100%; border-collapse:collapse; }

.feedback-rich-content td,.feedback-rich-content th { padding:6px; border:1px solid #e4dac9; }

.feedback-empty { margin:0; color:#89909b; font-size:11px; font-style:italic; }

.feedback-topic1 { padding-left:9px; border-left:2px solid #d7c6a6; }

.feedback-subtopic { margin:13px 0; padding:13px; border:1px solid #e5dac6; border-radius:7px; background:linear-gradient(145deg,#f8f4eb,#fffefa); scroll-margin-top:15px; }

.feedback-subtopic > p { margin:0 0 12px; padding:9px 11px; border-radius:4px; background:#eee5d4; color:#344e6b; font-weight:700; font-size:12px; }

.feedback-subtopic .feedback-question { margin:10px 0; }

.feedback-table-wrap { width:100%; overflow-x:auto; border:1px solid #e1d5bf; border-radius:6px; background:#fffefa; }

.feedback-matrix { width:100%; border-collapse:collapse; font-size:10px; line-height:1.5; }

.feedback-matrix th { padding:8px; background:#344e6b; color:#fffaf0; text-align:left; border:1px solid #536981; }

.feedback-matrix td { padding:7px; vertical-align:top; overflow-wrap:anywhere; border:1px solid #e5ddcf; }

.feedback-matrix tbody tr:nth-child(even) { background:#f7f3eb; }

.feedback-matrix p { margin:0 0 5px; }

@media(max-width:600px) {
  .feedback-book-overlay { padding:4px; }
  .feedback-book { width:100%; max-height:96vh; }
  .feedback-book-tabs { gap:4px; padding:10px 44px 10px 8px; }
  .feedback-book-tabs span { padding:6px; font-size:9px; }
  .feedback-book-page { padding:12px 10px; }
  .feedback-book-header { padding:8px; }
  .feedback-book-header h2 { font-size:14px; }
  .feedback-section-title { font-size:12px; margin:15px 0 9px; }
  .feedback-officer-details { grid-template-columns:1fr; column-gap:0; }
  .feedback-officer-details li { padding:8px 2px; }
  .feedback-subtopic { padding:9px; }
  .feedback-question { padding:10px; }

  
}
`}</style>


        </div>
    );
}
